import React from 'react';
import { Section } from './ui/Section';
import { X, Check } from 'lucide-react';
const withoutSystem = ['3 a 5 horas semanales planificando desde cero', 'Siempre los mismos ejercicios → los alumnos se aburren y abandonan', 'Alumnos que dejan sin saber por qué', 'Sin progresión clara de aparato en aparato', 'Alumno con dificultad = pánico o improvisación', 'Niveles mezclados = caos de clase permanente', 'Sin sistema de seguimiento claro ni evaluación', 'Sin identidad profesional visible ni justificada', 'Spotting improvisado = riesgo de lesiones'];
const withSystem = ['10 minutos por semana. El resto es estar en el piso con tus alumnos', '60+ clases distintas por aparato → siempre hay algo nuevo para dar', 'Sistema de progresión → retención visible desde el primer mes', '6 tomos con progresión anual completa → mejoran y se quedan', 'Protocolo de spotting → actuás con confianza y seguridad', 'Variaciones por nivel → todos mejoran juntos en la misma clase', 'Fichas y planillas listas para registrar con criterio profesional', 'Sistema que justifica cobrar lo que merecés', 'Protocolo de seguridad → cero improvisación ante riesgo'];
export function ComparisonSection() {
  return <Section data-id="element-46">
      <div className="text-center mb-6 md:mb-16" data-id="element-47">
        <h2 className="text-xl md:text-4xl font-black text-white" data-id="element-48">
          ¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>

      <div className="grid md:grid-cols-2 gap-3 md:gap-8 max-w-6xl mx-auto" data-id="element-49">
        {/* Without */}
        <div className="bg-navy-900 border border-red-900/50 rounded-2xl md:rounded-3xl p-4 md:p-8" data-id="element-50">
          <h3 className="text-sm md:text-xl font-bold text-red-400 mb-4 md:mb-8 text-center uppercase tracking-wide" data-id="element-51">
            SIN Gimnasia Artística Resuelta
          </h3>
          <ul className="space-y-2.5 md:space-y-5" data-id="element-52">
            {withoutSystem.map((item, i) => <li key={i} className="flex items-start space-x-2 md:space-x-3" data-id="element-53">
                <X className="w-4 h-4 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-54" />
                <span className="text-gray-400 text-xs md:text-base" data-id="element-55">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* With */}
        <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-green-500/30 rounded-2xl md:rounded-3xl p-4 md:p-8 relative overflow-hidden" data-id="element-56">
          <div className="absolute top-0 right-0 w-64 h-64 bg-green-500/5 blur-[100px] rounded-full pointer-events-none" data-id="element-57" />
          <h3 className="text-sm md:text-xl font-bold text-green-400 mb-4 md:mb-8 text-center uppercase tracking-wide relative z-10" data-id="element-58">
            CON Gimnasia Artística Resuelta
          </h3>
          <ul className="space-y-2.5 md:space-y-5 relative z-10" data-id="element-59">
            {withSystem.map((item, i) => <li key={i} className="flex items-start space-x-2 md:space-x-3" data-id="element-60">
                <Check className="w-4 h-4 md:w-6 md:h-6 text-green-400 flex-shrink-0 mt-0.5" data-id="element-61" />
                <span className="text-white font-medium text-xs md:text-base" data-id="element-62">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}